/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopupPrepaidByPSPTransaction
 */
export interface TopupPrepaidByPSPTransaction {
    /**
     * 
     * @type {string}
     * @memberof TopupPrepaidByPSPTransaction
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupPrepaidByPSPTransaction
     */
    externalPaymentReference?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupPrepaidByPSPTransaction
     */
    prepaidAccountId?: string;
}

/**
 * Check if a given object implements the TopupPrepaidByPSPTransaction interface.
 */
export function instanceOfTopupPrepaidByPSPTransaction(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TopupPrepaidByPSPTransactionFromJSON(json: any): TopupPrepaidByPSPTransaction {
    return TopupPrepaidByPSPTransactionFromJSONTyped(json, false);
}

export function TopupPrepaidByPSPTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopupPrepaidByPSPTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethodId': !exists(json, 'paymentMethodId') ? undefined : json['paymentMethodId'],
        'externalPaymentReference': !exists(json, 'externalPaymentReference') ? undefined : json['externalPaymentReference'],
        'prepaidAccountId': !exists(json, 'prepaidAccountId') ? undefined : json['prepaidAccountId'],
    };
}

export function TopupPrepaidByPSPTransactionToJSON(value?: TopupPrepaidByPSPTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentMethodId': value.paymentMethodId,
        'externalPaymentReference': value.externalPaymentReference,
        'prepaidAccountId': value.prepaidAccountId,
    };
}

